/* global __kimido */
import {
    FAVOURITES_SET_ERROR,
    FAVOURITES_SET_LIST,
    FAVOURITES_SET_PREV_COUNT
} from '../Actions/Favourites.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    list: __kimido.favourites ? __kimido.favourites : [],
    prevCount: __kimido.favourites ? __kimido.favourites.length : 0,
    errors: {}
}

export const favourites = (state = defaultState, action) => {
    const { type, payload } = action;

    switch (type) {
        case FAVOURITES_SET_LIST:
        case FAVOURITES_SET_PREV_COUNT:
            return {
                ...state,
                ...payload
            }
        case FAVOURITES_SET_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}
